const SelectedChatsState = {
  all: 'all',
  some: 'some',
  none: 'none',
};

export default SelectedChatsState;
